import { Portal } from '@mui/material'
import { AnimatePresence } from 'motion/react'
import React from 'react'

interface InlineModalProps {
  children: React.ReactElement<{ modalKey: string }>
  visible: boolean
  modalKey: string
}

const InlineModalPortal = (props: InlineModalProps) => {
  return <Portal>
    <AnimatePresence>
      {props.visible && React.cloneElement(props.children, {
        modalKey: props.modalKey,
      })}
    </AnimatePresence>
  </Portal>
}

export default InlineModalPortal